export default __webpack_public_path__ + "static/media/closedEye.935dc0e8.svg";